/*
 * @Author: your name
 * @Date: 2021-01-14 14:00:52
 * @LastEditTime: 2021-01-18 17:13:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /huzhu-zymutual2/src/store/modules/goodsDetails.js
 */
import * as types from '../mutations-types'

const state = {
	goodsDetails: {}
}

const getters = {
	goodsDetails : state => state.goodsDetails
}

const mutations = {
	[types.SET_GOODSDETAILS](state,obj){
		state.goodsDetails = obj
	}
}

export default {
  state,
  getters,
  // actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/goodsDetails.js